import { Apollo } from 'src/gql/generated';

/** Product display names for integration enums — GraphQL enum values are not user copy. */
export const INTEGRATION_DISPLAY_NAME = {
  [Apollo.Integration.Act]: 'Act!',
  [Apollo.Integration.ActiveCampaign]: 'ActiveCampaign',
  [Apollo.Integration.Close]: 'Close',
  [Apollo.Integration.Copper]: 'Copper',
  [Apollo.Integration.Gusto]: 'Gusto',
  [Apollo.Integration.HiBob]: 'HiBob',
  [Apollo.Integration.HubSpot]: 'HubSpot',
  [Apollo.Integration.MicrosoftDynamics]: 'Microsoft Dynamics',
  [Apollo.Integration.Pipedrive]: 'Pipedrive',
  [Apollo.Integration.Rippling]: 'Rippling',
  [Apollo.Integration.SageHr]: 'Sage HR',
  [Apollo.Integration.Salesflare]: 'Salesflare',
  [Apollo.Integration.SalesForce]: 'Salesforce',
  [Apollo.Integration.Teamleader]: 'Teamleader',
  [Apollo.Integration.Workday]: 'Workday',
  [Apollo.Integration.ZendeskSell]: 'Zendesk Sell',
  [Apollo.Integration.ZohoCrm]: 'Zoho CRM',
} satisfies Record<Apollo.Integration, string>;

export function getTemplatePublishedInTooltip(integration: Apollo.Integration) {
  return `This template is published in ${INTEGRATION_DISPLAY_NAME[integration]}`;
}
